import { render, staticRenderFns } from "./leaderboardTab.vue?vue&type=template&id=6e565026&lang=pug"
import script from "./leaderboardTab.vue?vue&type=script&lang=js"
export * from "./leaderboardTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports